<template>
    <section class="content-padding">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div class="card">
              <div class="card-header">
                <template v-if="!completed">
                  <h3 class="mb-1">
                    <label>ท่านพึงพอใจการฝึกอบรมของวิทยากรในระดับใด ? </label>
                  </h3>
                  <label> 1 = <span>{{ $t('message.operation_feedback.level01') }}</span> 5 = {{ $t('message.operation_feedback.level05') }}</label>
                </template>
              </div>
              <div class="card-body">
                <div v-if="loading">
                  <loader></loader>
                </div>
                <div v-else-if="!completed">
                  <form @submit.prevent="submitFeedback">
                    <div class="form-group">
                        <label for="trainingCenter">กรุณาเลือกศูนย์ฝึกอบรม<span class="text-danger">*</span></label>
                        <select class="form-control" id="trainingCenter" v-model="submitData.training_center_id" required>
                            <option value="">เลือกศูนย์ฝึกอบรม</option>
                            <option v-for="item in trainingCenter" :key="item.id" :value="item.id">{{ item.full_name }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="trainer">ผู้ฝึกอบรม<span class="text-danger">*</span></label>
                        <select class="form-control" id="trainer" v-model="submitData.trainer_id" :disabled="!submitData.training_center_id" required>
                            <option value="">เลือกผู้ฝึกอบรม</option>
                            <option v-for="item in trainers" :key="item.id" :value="item.id"><span v-if="item.nickname">{{ item.nickname }} - </span>{{ item.name }}</option>
                        </select>
                    </div>
                    <div class="card" v-for="item in topics" :key="item.topic">
                      <div class="card-header">
                        <label>{{ item.topic }}<span class="text-danger">*</span></label>
                      </div>
                      <div class="mt-3" v-for="content in item.content" :key="content">
                        <label class="ml-3">{{ content.th }}</label>
                        <div class="card-body score">
                          {{ $t('message.operation_feedback.level01') }}
                          <label class="radio-inline">
                            <input type="radio" value="1" v-model="submitData[content.en]" :name="`${content.en}_rating`"> 1
                          </label>
                          <label class="radio-inline">
                            <input type="radio" value="2" v-model="submitData[content.en]" :name="`${content.en}_rating`"> 2
                          </label>
                          <label class="radio-inline">
                            <input type="radio" value="3" v-model="submitData[content.en]" :name="`${content.en}_rating`"> 3
                          </label>
                          <label class="radio-inline">
                            <input type="radio" value="4" v-model="submitData[content.en]" :name="`${content.en}_rating`"> 4
                          </label>
                          <label class="radio-inline">
                            <input type="radio" value="5" v-model="submitData[content.en]" :name="`${content.en}_rating`" required> 5
                          </label>
                          {{ $t('message.operation_feedback.level05') }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="card">
                      <div class="card-header">
                        <label>ในการรับงานครั้งแรก หากทางบีนีทมีคุณแม่บ้านที่มีประสบการณ์เป็นพี่เลี้ยงเข้าให้บริการพร้อมกับคุณแม่บ้าน โดยที่มีการแบ่งรายได้ 50% ให้แก่คุณแม่บ้านพี่เลี้ยง คุณแม่บ้านมีความสนใจหรือไม่ ?</label>
                      </div>
                      <div class="card-body">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="mentorProgramInterest" :value="1" id="mentorProgramInterest1" v-model="submitData.mentor_program_interest" required>
                          <label class="form-check-label" for="mentorProgramInterest1">
                            สนใจ
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="mentorProgramInterest" :value="0" id="mentorProgramInterest2" v-model="submitData.mentor_program_interest">
                          <label class="form-check-label" for="mentorProgramInterest2">
                            ไม่สนใจ
                          </label>
                        </div>
                      </div>

                    </div> -->
                    <div class="card">
                      <div class="card-header">
                        <label>{{ $t('message.operation_feedback.suggestion') }}</label>
                      </div>
                      <div class="card-body">
                        <textarea class="form-control" rows="3" v-model="submitData.suggestions"></textarea>
                      </div>
                    </div>
                    <div style="margin-top:0.5em;">
                      <small class="fa-pull-left mt-3 text-muted">FMOR-01-00</small>
                      <button class="btn btn-success fa-pull-right">{{ $t('message.button.submit') }}</button>
                    </div>
                  </form>
                </div>
                <div v-else align="center">
                  <h3>
                    <label>{{ $t('message.operation_feedback.done') }}</label>
                    <div>
                      <img src="/static/img/mingcute_emoji-line.svg" alt width="90" >
                    </div> 
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>
<script>
import axios from 'axios'
import Loader from '../loader/Loader'
import StarRating from 'vue-star-rating'

export default {
  components: {
    Loader,
    StarRating
  },
  data () {
    return {
      rating: 0,
      comment: '',
      completed: false,
      reportProblem: '',
      reportProblemId: '',
      loading: false,
      saving: false,
      topics: [ {
        'topic': 'ด้านการฝึกอบรม',
        'content': [
          {'en': 'training_content_alignment', 'th': 'เนื้อหาในการฝึกอบรมตรงกับวัตถุประสงค์'},
          {'en': 'training_methods_appropriateness', 'th': 'รูปแบบและวิธีการฝึกอบรมมีความเหมาะสม'},
          {'en': 'training_material_comprehension', 'th': 'ความเข้าใจในคลิปวีดีโอและเอกสารการเรียนรู้'},
          {'en': 'training_material_confidence', 'th': 'คลิปวีดีโอและเอกสารการเรียนรู้ รวมถึงเอกสารข้อตกลงต่าง ๆ ช่วยสร้างความมั่นใจและสบายใจในการเป็นคุณแม่บ้านบีนีทมากขึ้น'},
          {'en': 'training_duration_appropriateness', 'th': 'ระยะเวลาในการฝึกอบรมมีความเหมาะสม'}
        ]
      },
      {
        'topic': 'ด้านวิทยากร',
        'content': [
          {'en': 'trainer_appearance', 'th': 'การแต่งกาย บุคลิกภาพโดยรวม'},
          {'en': 'trainer_knowledge_experience', 'th': 'ความรู้ ความสามารถ และประสบการณ์ของวิทยากร'},
          {'en': 'trainer_clarity_in_answers', 'th': 'การตอบคำถามชัดเจนตรงประเด็น'},
          {'en': 'trainer_openness_to_questions', 'th': 'เปิดโอกาสให้ซักถามและแสดงความคิดเห็น'},
          {'en': 'trainer_teaching_atmosphere', 'th': 'การสร้างบรรยากาศในการเรียนการสอน'}
        ]
      },
      {
        'topic': 'ด้านความรู้ความเข้าใจในการฝึกอบรม',
        'content': [
          {'en': 'pre_training_knowledge', 'th': 'ความรู้ก่อนฝึกอบรม'},
          {'en': 'post_training_knowledge', 'th': 'ความรู้หลังฝึกอบรม'}
        ]
      }
      ],
      submitData: {
        training_content_alignment: '',
        training_methods_appropriateness: '',
        training_material_comprehension: '',
        training_material_confidence: '',
        training_duration_appropriateness: '',
        trainer_appearance: '',
        trainer_knowledge_experience: '',
        trainer_clarity_in_answers: '',
        trainer_openness_to_questions: '',
        trainer_teaching_atmosphere: '',
        pre_training_knowledge: '',
        post_training_knowledge: '',
        suggestions: '',
        training_center_id: '',
        trainer_id: '',
        mentor_program_interest: 0
      },
      trainingCenter: [],
      trainers: []
    }
  },
  methods: {
    async submitFeedback () {
      const { data } = await axios.put(`/operation-professional-register-feedbacks/${this.feedbackId}`, this.submitData)
      if (!data.error) {
        this.completed = true
      }
    },
    async getFeedbackData () {
      this.loading = true
      this.feedbackId = this.$route.query.id
      if (!this.feedbackId) {
        await this.$swal('Error', this.$i18n.t('message.operation_feedback.error'), 'error')
        this.$router.push('/')
        return
      }
      try {
        const { data } = await axios.get(`/operation-professional-register-feedbacks/${this.feedbackId}`)
        console.log(data)
        if (!data.error) {
          this.feedback = data.feedback
          if (this.feedback.status === 1) {
            this.completed = true
          }
        }
        this.loading = false
      } catch (error) {
        await this.$swal('Error', error.message, 'error')
        this.$router.push('/')
      }
    },
    async getTrainingCenter () {
      const { data } = await axios.get('/training-center')
      if (!data.error) {
        this.trainingCenter = data.training_center
      }
    },
    async getTrainers (trainingCenterId) {
      this.trainers = []
      const { data } = await axios.get(`/trainer`)
      if (!data.error) {
        for (const item of data.trainers) {
          if (item.name.includes('ลาออก')) {
            continue
          }
          this.trainers.push(item)
        }
      }
    }
  },
  created () {
    this.getFeedbackData()
    this.getTrainingCenter()
    this.getTrainers()
  }
}
</script>
<style lang="scss" scoped>
.score {
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/components/feedback/ProfessionalRegisterFeedback.vue